export default "__VITE_ASSET__CLe7mJ_e__"